import * as React from 'react';
import ProviderOrganizationSharingrule from '../models/ProviderOrganizationSharingrule';
import {identity} from '../../core/auth/identityAuth';
import HttpService from '../../../modules/core/services/HttpService';
import Form from '../../shared/components/Form';
import CheckboxAllowDeny from '../../shared/components/checkbox-allow-deny/CheckboxAllowDeny';
import Checkbox from '@material-ui/core/Checkbox';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { withRouter } from 'react-router-dom';
import HttpCallConfig from '../../core/models/HttpCallConfig'

const httpService = HttpService.Instance;

class ProviderAssetOrganizations extends React.Component<any, any> {
  public assetOrganisationRightsForm: Form
  constructor(props: any) {
    super(props);
    this.saveData = this.saveData.bind(this);
    this.getOrganizationsRights = this.getOrganizationsRights.bind(this);
  }

  public getOrganizationsRights() {
    if (identity['nxt:entity:id']) {
      return httpService.get(process.env.REACT_APP_API_URL + 'entity/' + identity['nxt:entity:id'] + '/assets/' + this.props.assetId + '/providerorganizationsharingrules')
        .then((response: Response) => response.json())
        .then((data: ProviderOrganizationSharingrule[]) => {
          data.sort((a, b) => a.entityName.localeCompare(b.entityName));
          data.map((item: any) => {
            item.checkAllow = false;
            item.checkDeny = false;
            if (item.isAllowed) { item.checkAllow = true }
            if (item.isAllowed === false) { item.checkDeny = true }
          })
          return data
        });
    }
    return null
  }

  public async saveData(data: any[]) {
    if (identity['nxt:entity:id']) {
      data.map((item: any) => {
        item.isAllowed = null
        if (item.checkDeny) { item.isAllowed = false }
        if (item.checkAllow) { item.isAllowed = true }
      });
      const httpCallConfig = new HttpCallConfig;
      httpCallConfig.successMessage = 'Accessrights updated'
      return await httpService.post(process.env.REACT_APP_API_URL + 'entity/' + identity['nxt:entity:id'] + '/assets/' + this.props.assetId + '/providerorganizationsharingrules', data, httpCallConfig)
    }
    return null
  }

  public render() {
    return (
      <div>
        <Typography color="textSecondary" gutterBottom={true}>
          Asset &nbsp; &rang; Organization Access
                </Typography>
        <Form
          ref={(ref: Form) => this.assetOrganisationRightsForm = ref}
          history={this.props.history}
          saveFormPromise={this.saveData}
          getFormPromise={this.getOrganizationsRights}
          refreshHandler={
            (callback?: () => void) => {
              this.forceUpdate(() => {
                if (callback) { callback() }
              })
            }
          }
        >
          {this.assetOrganisationRightsForm && this.assetOrganisationRightsForm.formShadowData && this.assetOrganisationRightsForm.formShadowData.length < 1 &&
            <Typography>There is no organisation access management available for this asset.</Typography>
          }
          {this.assetOrganisationRightsForm && this.assetOrganisationRightsForm.formShadowData && this.assetOrganisationRightsForm.formShadowData.length > 0 &&
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Organization</TableCell>
                  <TableCell>Roles</TableCell>
                  <TableCell>Access via Role</TableCell>
                  <TableCell>Allow</TableCell>
                  <TableCell>Deny</TableCell>
                  <TableCell>Access</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.assetOrganisationRightsForm.formShadowData.map((consumer: any) => (
                  <TableRow key={consumer.sharingRuleId}>
                    <TableCell>{consumer.entityName}</TableCell>
                    <TableCell>
                      <i className="icon-users2 nxt-role-fs" data-toggle="tooltip" data-html="true" title="" />
                    </TableCell>
                    <TableCell>
                      <CheckboxAllowDeny
                        checked={consumer.isAllowedBySupplyChainRole}
                        disabled={true}
                      />
                    </TableCell>
                    <TableCell>
                      <Checkbox
                        name='checkAllow'
                        checked={consumer.checkAllow}
                        onChange={(e: any) => {
                          consumer.checkDeny = false;
                          this.assetOrganisationRightsForm.onChangeHandler(e, { itemRef: consumer })
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Checkbox
                        name='checkDeny'
                        checked={consumer.checkDeny}
                        onChange={(e: any) => {
                          consumer.checkAllow = false;
                          this.assetOrganisationRightsForm.onChangeHandler(e, { itemRef: consumer })
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <CheckboxAllowDeny
                        checked={(consumer.checkAllow || (consumer.isAllowedBySupplyChainRole && !consumer.checkDeny) ? true : false)}
                        disabled={true}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          }
        </Form>
      </div>
    )
  }
}

export default withRouter(ProviderAssetOrganizations)


// WEBPACK FOOTER //
// ./src/modules/provider/pages/ProviderAssetOrganizations.tsx